export const STORE_REQUIREMENT_NAMES = ['required', 'optional', 'none'];
//# sourceMappingURL=store-requirement-names.js.map